import { BaseService } from '../../../shared/base.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subject } from 'rxjs';
import { Notification } from './notification.model';
import { Client, IMessage } from '@stomp/stompjs';

@Injectable()
export class NotificationsService extends BaseService {

  private stompClient: Client;
  private connected = false;
  private connecting = false;
  private notificationSubject = new Subject<Notification>();

  constructor(protected http: HttpClient, protected router: Router, protected cookieService: CookieService){
    super( http, router, cookieService );

    this.stompClient = new Client( {
      brokerURL: `${ this.apiSocketUrl() }/notification-websocket`,
      reconnectDelay: 5000, // tenta reconectar a cada 5s
      heartbeatOutgoing: 50000,
      heartbeatIncoming: 0,
      connectHeaders: {
        Authorization: this.getJwtToken()
      },
      beforeConnect: () => {
        this.stompClient.connectHeaders = {
          Authorization: this.getJwtToken()
        };
      },
      onConnect: () => {
        console.log( '[WebSocket] Conectado' );
        this.connected = true;
        this.connecting = false;

        this.stompClient.subscribe( '/user/queue/notify', (message: IMessage) => {
          const notification = JSON.parse( message.body );
          this.notificationSubject.next( notification );
          this.stompClient.heartbeatOutgoing = 10000;
          this.stompClient.heartbeatIncoming = 0;
        } );
      },
      onWebSocketClose: (event) => {
        console.warn( '[WebSocket] Conexão encerrada', event.reason );
        this.connected = false;
        this.connecting = false;
      },
      onStompError: (frame) => {
        console.error( '[WebSocket] STOMP erro', frame );
        this.connected = false;
        this.connecting = false;
      }
    } );
  }

  isConnected(): boolean{
    return this.connected;
  }

  getNotifications(userId: string): Observable<Notification[]>{

    let params: HttpParams = new HttpParams();

    if ( !!userId ) {
      params = params.append( 'user', userId );
    }
    return this.get<Notification[]>( `/notifications`, this.httpOptions( params ) );
  }

  setAsRead(notification: Notification): Observable<Notification>{
    return this.patch<Notification>( `/notifications/${ notification.id }/read`, notification, this.httpOptions() );
  }

  connect(): Observable<Notification>{
    if ( !this.stompClient.active && !this.connected && !this.connecting ) {
      this.connecting = true;
      console.log( '[WebSocket] Ativando conexão...' );
      this.stompClient.activate();
    }

    return this.notificationSubject.asObservable();
  }

  disconnect(): void{
    if ( this.stompClient && this.stompClient.active ) {
      console.log( '[WebSocket] Desconectando...' );
      this.stompClient.deactivate();
    }
    this.connected = false;
    this.connecting = false;
  }
}
